import { create } from "zustand";
import { BookingDetailsDto } from "~/api/GeneratedApi";
import {
  AlarmSliceState,
  createAlarmIndicatorSlice,
} from "./stores/AlarmIndicatorSlice";
import {
  createMaterialTableFilteredSlice,
  FilterDataTypes,
} from "./stores/MaterialTableFilteredSlice";

export type StoreState = AlarmSliceState & FilterDataTypes<BookingDetailsDto>;

// export type GenericShitGenericShit<T> = StoreState<T>;

export const useBoundStore = create<StoreState>()((...a) => ({
  ...createAlarmIndicatorSlice(...a),
  ...createMaterialTableFilteredSlice(...a),
}));
